import { apiClient } from './client';

export interface OnboardingChecklist {
  id: number; employee_id: number; employee_name?: string; staff_id?: string;
  status: 'in_progress' | 'completed';
  total_tasks?: string; completed_tasks?: string;
}

export interface OnboardingTask {
  id: number; checklist_id: number; category: string; task_name: string;
  responsible_user_id: number | null; responsible_name: string | null; due_date: string | null;
  status: 'pending' | 'completed' | 'not_applicable'; completed_at: string | null; notes: string | null;
}

export const onboardingApi = {
  listAll: () => apiClient.get<{ data: OnboardingChecklist[] }>('/api/onboarding-checklists'),
  mine: () => apiClient.get<{ data: OnboardingChecklist | null; tasks: OnboardingTask[] }>('/api/onboarding/mine'),
  getForEmployee: (employeeId: number) => apiClient.get<{ data: OnboardingChecklist | null; tasks: OnboardingTask[] }>(`/api/employees/${employeeId}/onboarding`),
  createForEmployee: (employeeId: number) => apiClient.post<{ data: { id: number } }>(`/api/employees/${employeeId}/onboarding`),
  addTask: (checklistId: number, input: { category: string; taskName: string; responsibleUserId?: number; dueDate?: string }) =>
    apiClient.post<{ data: { id: number } }>(`/api/onboarding-checklists/${checklistId}/tasks`, input),
  completeTask: (taskId: number, input: { status: 'completed' | 'not_applicable'; notes?: string }) =>
    apiClient.post<{ data: { status: string } }>(`/api/onboarding-tasks/${taskId}/complete`, input),
  reopenTask: (taskId: number) => apiClient.post<{ data: { status: string } }>(`/api/onboarding-tasks/${taskId}/reopen`),
  completeChecklist: (id: number) => apiClient.post<{ data: { status: string } }>(`/api/onboarding-checklists/${id}/complete`),
};
